import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { FunnelPage } from './pages/Funnel';
import { AdminPage } from './pages/Admin';
import { PrivacyPolicyPage } from './pages/PrivacyPolicy';
import { TermsAndConditionsPage } from './pages/TermsAndConditions';
type CreativeKey = 'default' | '1br' | '2br' | '3br' | '4br' | '5br' | 'few_items';
interface AppProps {
  /** Ad size preselection. A ?creative_key= URL parameter overrides this. */
  creativeKey?: CreativeKey;
}
export function App({
  creativeKey = 'default'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="31agn4l9h89hv">
      <Routes data-id="element-1" data-mp="31ayrk56alu0v">
        <Route path="/" element={<FunnelPage creativeKey={creativeKey} data-id="element-3" data-mp="31c1jmgfcq2id" />} data-id="element-2" data-mp="31bib1qblcqh0" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-5" data-mp="2wifhhi6tdh0t" />} data-id="element-4" data-mp="2wjgtppzkg9k4" />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage data-id="element-7" data-mp="28te3lff7pdo5" />} data-id="element-6" data-mp="28ufp6dtutik4" />
        <Route path="/admin" element={<AdminPage data-id="element-9" data-mp="23vkuoemiy5k6" />} data-id="element-8" data-mp="28sb9kymlev40" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-11" data-mp="23ut9zyugts8o" />} data-id="element-10" data-mp="23u9tmmkgrbwr" />
      </Routes>
    </BrowserRouter>;
}